import React from 'react';
import { FadeIn, ExitingPersistence, isReducedMotion } from '@atlaskit/motion';
import { useTransitionView } from '../../../controllers/use-transition-view/index.tsx';
import type { MiniTransitionProps } from './types.tsx';

export const MiniTransition = ({ children, renderCondition }: MiniTransitionProps) => {
	const { onFinishAnimation, shouldRenderView } = useTransitionView('mini', renderCondition);
	if (isReducedMotion()) {
		if (renderCondition) {
			return <>{children({ transitionProps: {} })}</>;
		}
		return null;
	}
	return (
		<ExitingPersistence>
			{shouldRenderView && (
				<FadeIn
					entranceDirection="bottom"
					exitDirection="bottom"
					duration="medium"
					onFinish={onFinishAnimation}
				>
					{(fadeInProps) => children({ transitionProps: { ...fadeInProps } })}
				</FadeIn>
			)}
		</ExitingPersistence>
	);
};
